export const accessLevelsForDisplay = [
  "All-Access",
  "Limited Access",
  "Revoke",
] as const;
